import type { KpiItem } from '../../types/lists';
import { HelpPopover } from '../Shared/HelpPopover';

interface Props {
  items: KpiItem[];
  className?: string;
}

export function KpiStripList({ items, className = '' }: Props) {
  return (
    <div
      className={`grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3 ${className}`}
    >
      {items.map((k, i) => (
        <div
          key={`${k.label}-${i}`}
          className="rounded-xl border border-slate-200 bg-white px-3 sm:px-4 py-2.5 sm:py-3"
        >
          <div className="flex items-center gap-1.5">
            <span className="font-mono-num text-[10px] uppercase tracking-[0.18em] text-slate-400">
              {k.label}
            </span>
            {k.help && <HelpPopover label={k.help.label} text={k.help.text} />}
          </div>
          <div className="mt-1 flex items-baseline gap-1.5">
            <span className="font-mono-num text-[18px] sm:text-[22px] font-semibold text-slate-900 leading-none">
              {k.value}
            </span>
            {k.unit && (
              <span className="font-mono-num text-[11px] text-slate-500">
                {k.unit}
              </span>
            )}
            {k.sub && (
              <span className="text-[11px] text-slate-500 ml-auto">
                {k.sub}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
